import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { CurrencyHoverLayer } from './components/CurrencyHover'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Last-resort net: even a throw in App or Shell shows a branded reload
        rather than the white screen this class of bug used to cause. */}
    <ErrorBoundary variant="app">
      <App />
    </ErrorBoundary>
    {/* Once, for every screen. Beside the app rather than inside it, and
        wrapped in its own silent boundary, so a hover card can never be the
        reason the app shows its failure screen. */}
    <CurrencyHoverLayer />
  </StrictMode>,
)
